import data from "../../../../platform_common_constants/form_elements_constants.json"

export const dateRangePickerFields = { ...data.DATE_RANGE_PICKER_FIELDS, ALL: Object.values(data.DATE_RANGE_PICKER_FIELDS) }
